<template>
  <div :class="$style[$attrs.theme]">
    <div v-if="isPhoto" v-viewer="{ title: true, url: 'data-full-image' }" :class="$style.imgWrap" @click.stop>
      <RadialProgressBar
        v-if="message.content.localPath"
        :diameter="40"
        :innerStrokeWidth="4"
        :strokeWidth="4"
        startColor="#ffffff"
        stopColor="#ffffff"
        :completedSteps="message.progress && message.progress.loaded"
        :totalSteps="message.progress && message.progress.total"
        :class="$style.progress"
      />
      <img
        v-if="!message.content.localPath && message.content.info.mimetype === 'image/gif'"
        :src="pathFullImage"
        :width="imageDisplayRes.width"
        :height="imageDisplayRes.height"
        alt=""
        :class="$style.img"
      />
      <img
        v-if="!message.content.localPath && message.content.info.mimetype !== 'image/gif'"
        v-lazy="createLinkImage(message.content.url, message.content.info.w, message.content.info.h, 'scale')"
        :data-full-image="pathFullImage"
        :width="imageDisplayRes.width"
        :height="imageDisplayRes.height"
        :alt="message.content.body"
        :class="$style.img"
      />
      <img
        v-if="message.content.localPath"
        :src="message.content.localPath"
        :width="imageDisplayRes.width"
        :height="imageDisplayRes.height"
        :alt="message.content.body"
        :class="$style.img"
      />
    </div>
    <div style="position: relative" v-else-if="isVideo" @click.stop>
      <RadialProgressBar
        v-if="message.content.localPath"
        :diameter="40"
        :innerStrokeWidth="4"
        :strokeWidth="4"
        startColor="#ffffff"
        stopColor="#ffffff"
        :completedSteps="message.progress && message.progress.loaded"
        :totalSteps="message.progress && message.progress.total"
        :class="$style.progress"
      />
      <video
        :src="message.progress ? message.content.localPath : createFileUrl(message.content.url)"
        ref="video"
        :width="maxRes.maxWidth"
        preload="metadata"
        controls
      ></video>
    </div>
    <div v-else-if="isAudio" @click.stop>
      <div :class="$style.audioName">
        {{ message.content.name }}
        <div :class="$style.size">({{ superbytes(message.content.info.size) }})</div>
      </div>
      <audio :src="createFileUrl(message.content.url)" preload="metadata" controls></audio>
    </div>
    <a v-else :href="createFileUrl(message.content.url)" target="_blank" :class="$style.file" @click.stop>
      <div :class="[$style.iconWrap, $style[$attrs.theme]]">
        <RadialProgressBar
          v-if="message.content.localPath"
          :diameter="36"
          :innerStrokeWidth="2"
          :strokeWidth="2"
          startColor="#00b764"
          stopColor="#00b764"
          innerStrokeColor="#ffffff"
          :completedSteps="message.progress && message.progress.loaded"
          :totalSteps="message.progress && message.progress.total"
          :class="$style.progress"
        />
        <BaseIcon name="file" :class="$style.icon" />
      </div>
      <div>
        <a @click.stop :href="createFileUrl(message.content.url)" target="_blank">{{ message.content.body }}</a>
        <div :class="$style.size">({{ superbytes(message.content.info.size) }})</div>
      </div>
    </a>
  </div>
</template>

<script>
import superbytes from 'superbytes'
import RadialProgressBar from 'vue-radial-progress'
import { calculateAspectRatioFit } from '@/utils/helpers'
import { createLinkImage, createLinkImageFullPath } from '@/helpers'
import { msgTypes } from '@/helpers/variables'

export default {
  name: 'message-content-attachment',
  components: {
    RadialProgressBar
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    isForwarded: Boolean
  },
  data () {
    return {
      videoEl: null,
      videoSize: null
    }
  },
  mounted () {
    if (this.isVideo) {
      this.getVideoDisplayRes()
    }
  },
  computed: {
    typeName () {
      return this.message.content.msgtype
    },
    isPhoto () {
      return this.typeName === msgTypes.image
    },
    isVideo () {
      return this.typeName === msgTypes.video
    },
    isFile () {
      return this.typeName === msgTypes.file
    },
    isAudio () {
      return this.typeName === msgTypes.audio
    },
    imageRes () {
      if (!this.isPhoto) return
      const { w, h } = this.message.content.info
      return { width: w, height: h }
    },
    maxRes () {
      let maxWidth = 480
      let maxHeight = 320
      if (this.isForwarded) {
        maxWidth = 360
        maxHeight = 280
      }
      return {
        maxWidth,
        maxHeight
      }
    },
    imageDisplayRes () {
      if (!this.imageRes) return
      const { width, height } = this.imageRes
      const { maxWidth, maxHeight } = this.maxRes
      return calculateAspectRatioFit({
        width: width,
        height: height,
        maxWidth,
        maxHeight
      })
    },
    size () {
      return superbytes(this.message.attachment.size)
    },
    pathFullImage () {
      return this.message.event_id === 'local_last_message'
        ? this.message.content.url
        : createLinkImageFullPath(this.message.content.url)
    }
  },
  methods: {
    superbytes,
    createLinkImage,
    getVideoDisplayRes () {
      const el = this.$refs.video
      if (!el) return
      el.onloadedmetadata = () => {
        const { videoWidth, videoHeight } = el
        const { maxWidth, maxHeight } = this.maxRes
        const ratioSize = calculateAspectRatioFit({
          width: videoWidth,
          height: videoHeight,
          maxWidth,
          maxHeight
        })
        el.width = ratioSize.width
        el.height = ratioSize.height
      }
    },
    createFileUrl (url) {
      return window.matrixSDK.mxcUrlToHttp(url)
    }
  }
}
</script>

<style module lang="scss">
.green {
  .size {
    color: $white;
  }
  .iconWrap {
    background: $white;
  }
}
.text {
  margin-bottom: 6px;
}
.imgWrap {
  position: relative;
  font-size: 0;
}
.progress {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
}
.img {
  // max-width: 85%;
  // max-height: 300px;
  object-fit: contain;
  max-width: 100% !important;
  // object-position: left top;
}
.iconWrap {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($main-bg-colored, 0.15);
  margin-right: 8px;
  flex-shrink: 0;
  position: relative;
}
.icon {
  font-size: 20px;
  color: $text-colored;
}
.file {
  display: flex;
  align-items: center;
}
.size {
  color: $text-light;
  font-size: 12px;
}
.audioName {
  margin-bottom: 6px;
}
</style>
